import { SET_ORDERS, SET_ORDER_LOCALLY_FOR_PAYMENT_BULK, SET_ORDER_LOCALLY_FOR_PAYMENT, REMOVE_ORDER, ADD_SESSION_ORDER_WS, ADD_SESSION_ORDER, UPDATE_ORDER_WS, UPDATE_ORDER, REPLACE_ORDER_TABLET_GENERATED_ID_WS, UPDATE_ORDER_FIELD, UPDATE_LICENSE_EDITING_ID_WS, UPDATE_LICENSE_EDITING_ID, EXITING_FROM_ORDER, LEAVING_ORDER_WS, SET_TICKET_ELEMENT_ITEM_OBJ, ADD_MODIFIER_ITEM_TO_MODIFIER_GROUP_ITEM_OBJ, KITCHEN_ITEM_CLEAR_PRINTING_ERROR, REMOVE_TICKET_ELEMENT, SELECT_SUBCATEGORY_CUSTOMIZER, SELECT_REGISTER_ITEM, SELECT_REGISTER_COMBO, SELECT_REGISTER_COMBO_ITEM, REMOVE_REGISTER_COMBO_ITEM, DUPLICATE_COMBO_ELEMENT, DUPLICATE_TICKET_ELEMENT, UPDATE_TICKET_MODIFIER_GROUP_ITEM, SET_TICKET_ELEMENT_UN_SHARE, UPDATE_LOCALLY_ORDER_FIELD, ADD_SPECIAL_ORDER_OBJECT, UPDATE_ORDER_SEARCH_RESULTS, ROLL_UP_ORDER_SEARCH_CHECK_ELEMENTS, TOGGLE_TICKET_ELEMENT_SEAT_SHARED, DECREMENT_COMBO_SEAT_QUANTITY, DECREMENT_SEAT_QUANTITY, INCREMENT_COMBO_SEAT_QUANTITY, INCREMENT_SEAT_QUANTITY, SET_COMBO_SEAT_QUANTITY, SET_SEAT_QUANTITY, SET_SEAT_TAGS, TOGGLE_COMBO_SEAT_QUANTITY, TOGGLE_SEAT_QUANTITY, UPDATE_TICKET_ELEMENT_FIELD, RESET_TICKET_SPECIALS, UPDATE_TICKET_ELEMENT_COURSE, UPDATE_TICKET_ELEMENT_INSTRUCTIONS, RESET_MODIFIER_GROUP_SELECTED, SELECT_NONE_MODIFIER_ITEMS_CUSTOMIZER, DELETE_TICKET_MODIFIER_ITEM_SELECTED, INCREMENT_MODIFIER_ITEM_SELECTED, DECREMENT_MODIFIER_ITEM_SELECTED, TOGGLE_NESTED_MODIFIER_ITEM_SELECTED, INCREMENT_NESTED_MODIFIER_ITEM_SELECTED, DELETE_NESTED_MODIFIER_ITEM_SELECTED, DECREMENT_NESTED_MODIFIER_ITEM_SELECTED, TOGGLE_NONE_NESTED_MODIFIER_ITEM_SELECTED, UPDATE_COMPLETED_SECTIONS, UPDATE_MODIFIER_PRICE, UNGROUP_COMBO_ELEMENT_BY_SEATS, UNGROUP_TICKET_ELEMENT_BY_SEATS, UNGROUP_COMBO_ELEMENT_BY_SINGLE_SEAT, UNGROUP_TICKET_ELEMENT_BY_SINGLE_SEAT, UNGROUP_COMBO_ELEMENT_BY_QTY, UNGROUP_TICKET_ELEMENT_BY_QTY, UPDATE_TICKET_ELEMENT_VOIDED, UPDATE_COMBO_ELEMENT_VOIDED, COPY_SENT_TICKET_ELEMENT_CONFIG, UPDATE_COMBO_OBJECT_PREVIEW, SELECT_CURRENT_SEAT, SELECT_NEXT_SEAT, SELECT_PREVIOUS_SEAT, SET_COMBO_ELEMENT_SHARE, SET_TICKET_ELEMENT_SHARE, SET_ORDER_SEARCH_RESULTS, RESET_ORDER_SEARCH_RESULTS_BAR_CODE_ORDER, RESET_MODIFIER_GROUP_SELECTED_TO_CONFIG_WHEN_SENT, MOVE_CHECK_ELEMENTS, MOVE_PAYMENTS, RENAME_CHECK, CLOSE_CHECK, MERGE_CHECKS, DELETE_EDITABLE_CHECK, DELETE_ALL_EDITABLE_CHECKS, UN_SPLIT_CHECK_ELEMENT, CARRY_OVER_MODIFIERS_SELECTED, APPLY_SPECIAL_TO_TICKET, ROLL_UP_TICKET_ELEMENTS, ROLL_UP_COMBO_ELEMENTS, CLEAR_ALL_SEAT_TAGS, MODIFY_ITEM_END, DELETE_EMPTY_CHECKS, MAKE_COMBO_FROM_TICKET_ITEM, REMOVE_COMBO_ELEMENT, CANCEL_COMBO_ELEMENT, SET_COMBO_ELEMENT_QUANTITY, SET_TICKET_ELEMENT_QUANTITY, INCREMENT_NUMBER_OF_SEATS, SET_TICKET_MODIFIER_GROUPS_SELECTED, SELECT_NONE_MODIFIER_ITEMS, TOGGLE_MODIFIER_ITEM_SELECTED, APPLY_DISCOUNT_TO_ORDER, UPDATE_ORDER_DISCOUNT, UPDATE_TICKET_COMBO_DISCOUNT, UPDATE_TICKET_ELEMENT_DISCOUNT, CLEAR_UNSENT_ITEMS, APPLY_DISCOUNT_TO_ITEMS, REMOVE_DISCOUNT_FROM_COMBO, REMOVE_DISCOUNT_FROM_ITEM, REMOVE_DISCOUNT_FROM_ORDER, TOGGLE_TICKET_ELEMENT_ON_HOLD, UPDATE_COMBO_ELEMENT_BASE_PRICE, UPDATE_TICKET_ELEMENT_BASE_PRICE, REVERT_TICKET_ELEMENT_BASE_PRICE, CREATE_CHECK, ROLL_UP_CHECK_ELEMENTS, UPDATE_CHECK_ORDER_DISCOUNTS, VOID_ALL_CHECKS, DUMP_DEFAULT_CHECK, CLEAN_DISPLAY_CHECK_ELEMENTS, CREATE_DISPLAY_CHECK_ELEMENTS, SPLIT_CHECK_ELEMENTS_WAYS, SPLIT_CHECK_ELEMENT_EVENLY, UNGROUP_CHECK_ELEMENTS, SPLIT_CHECK_BY_SEATS, SPLIT_CHECK_ELEMENT_BY_SEATS, SPLIT_CHECK_INTO_N_NEW_CHECKS, OPEN_CHECK, VOID_CHECK, ADD_CHECK_PAYMENT, VOID_PAYMENT, TRANSFER_PAYMENT, UPDATE_PAYMENT, TOGGLE_ITEM_INGREDIENT, INCREMENT_ITEM_INGREDIENT, DECREMENT_ITEM_INGREDIENT, APPLY_PAYMENT_TIP_ADJUSTMENT, ADD_REGISTER_OPEN_ITEM, MODIFY_ITEM_START, UPDATE_FIRE_TIMES_FIELD, VOID_ORDER, FLUSH_DEBOUNCE_UPDATE_ORDER, SWITCH_PRICE_LIST } from './chunk-5J2PASRY.mjs';
import { __export, __spreadValues, __spreadProps } from './chunk-T36PI2YV.mjs';

// src/state/register/orders/actionCreators.ts
var actionCreators_exports = {};
__export(actionCreators_exports, {
  addCheckPayment: () => addCheckPayment,
  addModifierItemToModifierGroupItemObj: () => addModifierItemToModifierGroupItemObj,
  addRegisterOpenItem: () => addRegisterOpenItem,
  addSessionOrder: () => addSessionOrder,
  addSpecialObjectsToOrder: () => addSpecialObjectsToOrder,
  applyDiscountToItem: () => applyDiscountToItem,
  applyDiscountToOrder: () => applyDiscountToOrder,
  applySpecialToTicket: () => applySpecialToTicket,
  applyTipToOrder: () => applyTipToOrder,
  cancelComboElement: () => cancelComboElement,
  carryOverModifiersSelected: () => carryOverModifiersSelected,
  cleanDisplayCheckElements: () => cleanDisplayCheckElements,
  clearAllSeatTags: () => clearAllSeatTags,
  clearUnsentItems: () => clearUnsentItems,
  closeCheck: () => closeCheck,
  copySentTicketElementConfig: () => copySentTicketElementConfig,
  createCheck: () => createCheck,
  createDisplayCheckElements: () => createDisplayCheckElements,
  decrementItemIngredient: () => decrementItemIngredient,
  decrementModifierItemSelected: () => decrementModifierItemSelected,
  decrementNestedModifierItemSelected: () => decrementNestedModifierItemSelected,
  decrementSeatQuantity: () => decrementSeatQuantity,
  deleteAllEditableChecks: () => deleteAllEditableChecks,
  deleteEditableCheck: () => deleteEditableCheck,
  deleteEmptyChecks: () => deleteEmptyChecks,
  deleteNestedModifierItemSelected: () => deleteNestedModifierItemSelected,
  deleteTicketModifierItemSelected: () => deleteTicketModifierItemSelected,
  dumpDefaultCheck: () => dumpDefaultCheck,
  duplicateTicketElement: () => duplicateTicketElement,
  enterToOrderAction: () => enterToOrderAction,
  exitFromOrderAction: () => exitFromOrderAction,
  finishItemModifyingAction: () => finishItemModifyingAction,
  flushDebounceUpdate: () => flushDebounceUpdate,
  incrementItemIngredient: () => incrementItemIngredient,
  incrementModifierItemSelected: () => incrementModifierItemSelected,
  incrementNestedModifierItemSelected: () => incrementNestedModifierItemSelected,
  incrementNumberOfSeatsOccupied: () => incrementNumberOfSeatsOccupied,
  incrementSeatQuantity: () => incrementSeatQuantity,
  kitchenItemClearPrintingError: () => kitchenItemClearPrintingError,
  leavingOrderActionWS: () => leavingOrderActionWS,
  makeComboFromTicketElement: () => makeComboFromTicketElement,
  mergeChecks: () => mergeChecks,
  moveCheckElements: () => moveCheckElements,
  movePayments: () => movePayments,
  openCheck: () => openCheck,
  removeComboElement: () => removeComboElement,
  removeDiscountFromElement: () => removeDiscountFromElement,
  removeDiscountFromOrder: () => removeDiscountFromOrder,
  removeOrder: () => removeOrder,
  removeRegisterComboItem: () => removeRegisterComboItem,
  removeTicketElement: () => removeTicketElement,
  renameCheck: () => renameCheck,
  replaceOrderTabletGeneratedId: () => replaceOrderTabletGeneratedId,
  replaceSessionOrder: () => replaceSessionOrder,
  resetModifierGroupSelected: () => resetModifierGroupSelected,
  resetModifierGroupSelectedToConfigWhenSent: () => resetModifierGroupSelectedToConfigWhenSent,
  resetOrderSearchResultBarCodeOrder: () => resetOrderSearchResultBarCodeOrder,
  resetTicketSpecials: () => resetTicketSpecials,
  revertTicketElementPriceByTicketElementId: () => revertTicketElementPriceByTicketElementId,
  rollUpOrderCheckElements: () => rollUpOrderCheckElements,
  rollUpOrderSearchCheckElements: () => rollUpOrderSearchCheckElements,
  rollUpTicketCombos: () => rollUpTicketCombos,
  rollUpTicketElements: () => rollUpTicketElements,
  selectCustomizerSubcategory: () => selectCustomizerSubcategory,
  selectNoneModifierItems: () => selectNoneModifierItems,
  selectNoneNestedModifierItemSelected: () => selectNoneNestedModifierItemSelected,
  selectRegisterCombo: () => selectRegisterCombo,
  selectRegisterComboItem: () => selectRegisterComboItem,
  selectRegisterItem: () => selectRegisterItem,
  selectTicketCurrentSeat: () => selectTicketCurrentSeat,
  selectTicketNextSeat: () => selectTicketNextSeat,
  selectTicketPreviousSeat: () => selectTicketPreviousSeat,
  setCurrentTicketElementItemObj: () => setCurrentTicketElementItemObj,
  setModifierGroupSelected: () => setModifierGroupSelected,
  setOrderLocallyForPayment: () => setOrderLocallyForPayment,
  setOrderSearchResult: () => setOrderSearchResult,
  setOrders: () => setOrders,
  setSeatQuantity: () => setSeatQuantity,
  setSeatTags: () => setSeatTags,
  setTicketElementQuantity: () => setTicketElementQuantity,
  setTicketElementShared: () => setTicketElementShared,
  splitCheckBySeats: () => splitCheckBySeats,
  splitCheckElementBySeats: () => splitCheckElementBySeats,
  splitCheckElementEvenly: () => splitCheckElementEvenly,
  splitCheckElementsWays: () => splitCheckElementsWays,
  splitCheckIntoNNewChecks: () => splitCheckIntoNNewChecks,
  startItemModifying: () => startItemModifying,
  switchOrderListPrice: () => switchOrderListPrice,
  toggleItemIngredient: () => toggleItemIngredient,
  toggleModifierItemSelected: () => toggleModifierItemSelected,
  toggleNestedModifierItemSelected: () => toggleNestedModifierItemSelected,
  toggleNoneNestedModifierItemSelected: () => toggleNoneNestedModifierItemSelected,
  toggleOnHoldByTicketElementIdAndOrderId: () => toggleOnHoldByTicketElementIdAndOrderId,
  toggleSeatQuantity: () => toggleSeatQuantity,
  toggleTicketElementSeatShared: () => toggleTicketElementSeatShared,
  transferPayment: () => transferPayment,
  unShareTicketElement: () => unShareTicketElement,
  unSplitCheckElement: () => unSplitCheckElement,
  ungroupCheckElements: () => ungroupCheckElements,
  ungroupTicketElementByQty: () => ungroupTicketElementByQty,
  ungroupTicketElementBySeats: () => ungroupTicketElementBySeats,
  ungroupTicketElementBySingleSeat: () => ungroupTicketElementBySingleSeat,
  updateCheckOrderDiscounts: () => updateCheckOrderDiscounts,
  updateComboElementVoided: () => updateComboElementVoided,
  updateComboObjectPreview: () => updateComboObjectPreview,
  updateCompletedSections: () => updateCompletedSections,
  updateFireTimesField: () => updateFireTimesField,
  updateModifierPrices: () => updateModifierPrices,
  updateOrderData: () => updateOrderData,
  updateOrderDiscount: () => updateOrderDiscount,
  updateOrderSearchResultData: () => updateOrderSearchResultData,
  updatePayment: () => updatePayment,
  updateSessionOrder: () => updateSessionOrder,
  updateTicketElementBasePriceByTicketElementId: () => updateTicketElementBasePriceByTicketElementId,
  updateTicketElementCourse: () => updateTicketElementCourse,
  updateTicketElementField: () => updateTicketElementField,
  updateTicketElementInstructions: () => updateTicketElementInstructions,
  updateTicketElementVoided: () => updateTicketElementVoided,
  updateTicketItemDiscount: () => updateTicketItemDiscount,
  updateTicketModifierGroupItem: () => updateTicketModifierGroupItem,
  voidAllChecks: () => voidAllChecks,
  voidCheck: () => voidCheck,
  voidOrderAction: () => voidOrderAction,
  voidPayment: () => voidPayment
});
var setOrders = (payload) => ({
  type: SET_ORDERS,
  payload
});
var setOrderLocallyForPayment = (order, isBulk = false) => ({
  type: isBulk ? SET_ORDER_LOCALLY_FOR_PAYMENT_BULK : SET_ORDER_LOCALLY_FOR_PAYMENT,
  payload: order
});
var removeOrder = (orderId) => ({
  type: REMOVE_ORDER,
  payload: orderId
});
var addSessionOrder = (payload, id, ws, updateTotals = true) => ({
  type: ws ? ADD_SESSION_ORDER_WS : ADD_SESSION_ORDER,
  payload,
  id,
  updateTotals
});
var replaceSessionOrder = (payload, ws) => ({
  type: ws ? UPDATE_ORDER_WS : UPDATE_ORDER,
  payload
});
var replaceOrderTabletGeneratedId = (tabletGeneratedId, orderId, tableId, defaultCheckId) => ({
  type: REPLACE_ORDER_TABLET_GENERATED_ID_WS,
  payload: {
    tabletGeneratedId,
    defaultCheckId,
    orderId,
    tableId
  }
});
var updateSessionOrder = (payload) => ({
  type: UPDATE_ORDER_FIELD,
  payload
});
var enterToOrderAction = (payload, ws) => ({
  type: ws ? UPDATE_LICENSE_EDITING_ID_WS : UPDATE_LICENSE_EDITING_ID,
  payload
});
var exitFromOrderAction = (payload, orderId) => ({
  type: EXITING_FROM_ORDER,
  payload,
  orderId
});
var leavingOrderActionWS = (payload, orderId) => ({
  type: LEAVING_ORDER_WS,
  payload,
  orderId
});
var setCurrentTicketElementItemObj = (payload) => ({
  type: SET_TICKET_ELEMENT_ITEM_OBJ,
  payload
});
var addModifierItemToModifierGroupItemObj = (payload) => ({
  type: ADD_MODIFIER_ITEM_TO_MODIFIER_GROUP_ITEM_OBJ,
  payload
});
var kitchenItemClearPrintingError = (payload) => ({
  type: KITCHEN_ITEM_CLEAR_PRINTING_ERROR,
  payload
});
var removeTicketElement = (orderId, ticketElementId) => ({
  type: REMOVE_TICKET_ELEMENT,
  payload: {
    orderId,
    ticketElementId
  }
});
var selectCustomizerSubcategory = (payload) => ({
  type: SELECT_SUBCATEGORY_CUSTOMIZER,
  payload
});
var selectRegisterItem = (payload) => ({
  type: SELECT_REGISTER_ITEM,
  payload
});
var selectRegisterCombo = (payload) => ({
  type: SELECT_REGISTER_COMBO,
  payload
});
var selectRegisterComboItem = (payload) => ({
  type: SELECT_REGISTER_COMBO_ITEM,
  payload
});
var removeRegisterComboItem = (payload) => ({
  type: REMOVE_REGISTER_COMBO_ITEM,
  payload
});
var duplicateTicketElement = (orderId, oldTicketElementId, newTicketElementId, currentSeat, seatSplitRequired, isSeatingEnabled, skipInventoryCheck = false, isCombo = false, isReorder = false, nextCourseNumber) => ({
  type: isCombo ? DUPLICATE_COMBO_ELEMENT : DUPLICATE_TICKET_ELEMENT,
  payload: {
    orderId,
    prevTicketElementId: oldTicketElementId,
    newTicketElementId,
    currentSeat,
    seatSplitRequired,
    isSeatingEnabled,
    skipInventoryCheck,
    isReorder,
    nextCourseNumber
  }
});
var updateTicketModifierGroupItem = (orderId, ticketElementId, modifierGroupId, modifierItemSelected, modifierItemsWithNested) => ({
  type: UPDATE_TICKET_MODIFIER_GROUP_ITEM,
  payload: {
    orderId,
    ticketElementId,
    modifierGroupId,
    modifierItemSelected,
    modifierItemsWithNested
  }
});
var unShareTicketElement = (orderId, ticketElementId, isForTableEnabled, isSeatingModeEnabled, isCombo) => ({
  type: SET_TICKET_ELEMENT_UN_SHARE,
  payload: {
    orderId,
    ticketElementId,
    isForTableEnabled,
    isSeatingModeEnabled,
    isCombo
  }
});
var updateOrderData = (orderId, orderUpdate, isLocally) => ({
  type: isLocally ? UPDATE_LOCALLY_ORDER_FIELD : UPDATE_ORDER_FIELD,
  payload: {
    orderId,
    orderUpdate
  }
});
var addSpecialObjectsToOrder = (orderId, specialObjects) => ({
  type: ADD_SPECIAL_ORDER_OBJECT,
  payload: { orderId, specialObjects }
});
var updateOrderSearchResultData = (orderId, orderData) => ({
  type: UPDATE_ORDER_SEARCH_RESULTS,
  payload: {
    orderId,
    orderData
  }
});
var rollUpOrderSearchCheckElements = (orderId) => ({
  type: ROLL_UP_ORDER_SEARCH_CHECK_ELEMENTS,
  payload: {
    orderId
  }
});
var toggleTicketElementSeatShared = (orderId, ticketElementId, seatId, isSeatingModeEnabled, isCombo) => ({
  type: TOGGLE_TICKET_ELEMENT_SEAT_SHARED,
  payload: {
    orderId,
    ticketElementId,
    seatId,
    isSeatingModeEnabled,
    isCombo
  }
});
var decrementSeatQuantity = (orderId, ticketElementId, seatId, isCombo, isSeatingModeEnabled) => ({
  type: isCombo ? DECREMENT_COMBO_SEAT_QUANTITY : DECREMENT_SEAT_QUANTITY,
  payload: {
    orderId,
    ticketElementId,
    seatId,
    isCombo,
    isSeatingModeEnabled
  }
});
var incrementSeatQuantity = (orderId, ticketElementId, seatId, isCombo) => ({
  type: isCombo ? INCREMENT_COMBO_SEAT_QUANTITY : INCREMENT_SEAT_QUANTITY,
  payload: {
    orderId,
    ticketElementId,
    seatId,
    isCombo,
    isSeatingModeEnabled: true
  }
});
var setSeatQuantity = (orderId, ticketElementId, seatId, quantity, isCombo) => ({
  type: isCombo ? SET_COMBO_SEAT_QUANTITY : SET_SEAT_QUANTITY,
  payload: {
    orderId,
    ticketElementId,
    seatId,
    quantity,
    isCombo,
    isSeatingModeEnabled: true
  }
});
var setSeatTags = (orderId, seatId, seatTags) => ({
  type: SET_SEAT_TAGS,
  payload: {
    orderId,
    seatId,
    seatTags
  }
});
var toggleSeatQuantity = (orderId, ticketElementId, seatId, quantity, isCombo, isMultiSeatEnabled) => ({
  type: isCombo ? TOGGLE_COMBO_SEAT_QUANTITY : TOGGLE_SEAT_QUANTITY,
  payload: {
    orderId,
    ticketElementId,
    seatId,
    isCombo,
    quantity,
    isSeatingModeEnabled: true,
    isMultiSeatEnabled
  }
});
var updateTicketElementField = (ticketElementUpdate, orderId, ticketElementId, isSeatingModeEnabled) => ({
  type: UPDATE_TICKET_ELEMENT_FIELD,
  payload: {
    orderId,
    ticketElementId,
    ticketElementUpdate,
    isSeatingModeEnabled
  }
});
var resetTicketSpecials = (payload) => ({
  type: RESET_TICKET_SPECIALS,
  payload
});
var updateTicketElementCourse = (data, orderId, ticketElementId, currentSeat, isSeatingModeEnabled, seatSplitRequired, coursingMode) => ({
  type: UPDATE_TICKET_ELEMENT_COURSE,
  payload: {
    orderId,
    ticketElementId,
    data,
    isSeatingModeEnabled,
    currentSeat,
    seatSplitRequired,
    coursingMode
  }
});
var updateTicketElementInstructions = (data, orderId, ticketElementId, currentSeat, seatSplitRequired, isSeatingModeEnabled) => ({
  type: UPDATE_TICKET_ELEMENT_INSTRUCTIONS,
  payload: {
    orderId,
    ticketElementId,
    data,
    currentSeat,
    seatSplitRequired,
    isSeatingModeEnabled
  }
});
var resetModifierGroupSelected = (orderId, ticketElementId, modifierGroupId, currentSeat, seatSplitRequired, isSeatingModeEnabled, isIngredientsActive, globalState) => ({
  type: RESET_MODIFIER_GROUP_SELECTED,
  payload: {
    orderId,
    ticketElementId,
    modifierGroupId,
    currentSeat,
    seatSplitRequired,
    isSeatingModeEnabled,
    isIngredientsActive,
    globalState
  }
});
var selectNoneNestedModifierItemSelected = (payload, seatingData) => ({
  type: SELECT_NONE_MODIFIER_ITEMS_CUSTOMIZER,
  payload: __spreadValues(__spreadValues({}, payload), seatingData)
});
var deleteTicketModifierItemSelected = (orderId, ticketElementId, modifierGroupId, modifierItemId, customizer, seatingData, globalState) => ({
  type: DELETE_TICKET_MODIFIER_ITEM_SELECTED,
  payload: __spreadValues({
    orderId,
    ticketElementId,
    modifierGroupId,
    modifierItemId,
    customizer,
    globalState
  }, seatingData)
});
var incrementModifierItemSelected = (orderId, ticketElementId, modifierGroupId, modifierItemId, customizer, seatSplitRequired, currentSeat, isSeatingModeEnabled, globalState, sortPriority) => ({
  type: INCREMENT_MODIFIER_ITEM_SELECTED,
  payload: {
    orderId,
    ticketElementId,
    modifierGroupId,
    modifierItemId,
    customizer,
    currentSeat,
    seatSplitRequired,
    isSeatingModeEnabled,
    globalState,
    sortPriority
  }
});
var decrementModifierItemSelected = (orderId, ticketElementId, modifierGroupId, modifierItemId, customizer, seatSplitRequired, currentSeat, isSeatingModeEnabled, globalState, sortPriority) => ({
  type: DECREMENT_MODIFIER_ITEM_SELECTED,
  payload: {
    orderId,
    ticketElementId,
    modifierGroupId,
    modifierItemId,
    customizer,
    seatSplitRequired,
    currentSeat,
    isSeatingModeEnabled,
    globalState,
    sortPriority
  }
});
var toggleNestedModifierItemSelected = (orderId, ticketElementId, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, modifierTag, seatingData, globalState, operation) => ({
  type: TOGGLE_NESTED_MODIFIER_ITEM_SELECTED,
  payload: __spreadValues({
    orderId,
    ticketElementId,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId,
    modifierTag,
    globalState,
    operation
  }, seatingData)
});
var incrementNestedModifierItemSelected = (orderId, ticketElementId, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, seatingData) => ({
  type: INCREMENT_NESTED_MODIFIER_ITEM_SELECTED,
  payload: __spreadValues({
    orderId,
    ticketElementId,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId
  }, seatingData)
});
var deleteNestedModifierItemSelected = (orderId, ticketElementId, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, isSeatingModeEnabled) => ({
  type: DELETE_NESTED_MODIFIER_ITEM_SELECTED,
  payload: {
    orderId,
    ticketElementId,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId,
    isSeatingModeEnabled
  }
});
var decrementNestedModifierItemSelected = (orderId, ticketElementId, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, seatingData) => ({
  type: DECREMENT_NESTED_MODIFIER_ITEM_SELECTED,
  payload: __spreadValues({
    orderId,
    ticketElementId,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId
  }, seatingData)
});
var toggleNoneNestedModifierItemSelected = (orderId, ticketElementId, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, seatingData) => ({
  type: TOGGLE_NONE_NESTED_MODIFIER_ITEM_SELECTED,
  payload: __spreadValues({
    orderId,
    ticketElementId,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId
  }, seatingData)
});
var updateCompletedSections = (orderId, ticketElementId, isSeatingModeEnabled, parentModifierGroupId = 0, parentModifierItemId = 0, isNested = false, parentModifierInstanceId = 0, nestedModifierGroupId = 0) => ({
  type: UPDATE_COMPLETED_SECTIONS,
  payload: {
    orderId,
    ticketElementId,
    isSeatingModeEnabled,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    isNested,
    nestedModifierGroupId
  }
});
var updateModifierPrices = (orderId, ticketElementId, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId) => ({
  type: UPDATE_MODIFIER_PRICE,
  payload: {
    orderId,
    ticketElementId,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId
  }
});
var ungroupTicketElementBySeats = (orderId, ticketElementSeatMap, isCombo) => ({
  type: isCombo ? UNGROUP_COMBO_ELEMENT_BY_SEATS : UNGROUP_TICKET_ELEMENT_BY_SEATS,
  payload: {
    orderId,
    ticketElementSeatMap,
    isCombo
  }
});
var ungroupTicketElementBySingleSeat = (orderId, ticketElementId, newTicketElementId, seatId, quantity, isCombo) => ({
  type: isCombo ? UNGROUP_COMBO_ELEMENT_BY_SINGLE_SEAT : UNGROUP_TICKET_ELEMENT_BY_SINGLE_SEAT,
  payload: {
    orderId,
    ticketElementId,
    newTicketElementId,
    seatId,
    quantity,
    isCombo
  }
});
var ungroupTicketElementByQty = (orderId, ticketElementId, quantity, newTicketElementId, isCombo) => ({
  type: isCombo ? UNGROUP_COMBO_ELEMENT_BY_QTY : UNGROUP_TICKET_ELEMENT_BY_QTY,
  payload: {
    orderId,
    ticketElementId,
    quantity,
    newTicketElementId,
    isCombo
  }
});
var updateTicketElementVoided = (orderId, ticketElementId, isVoided, voidedReasonId, prepStationIds, printJobIdsPerPrepStation) => ({
  type: UPDATE_TICKET_ELEMENT_VOIDED,
  payload: {
    orderId,
    ticketElementId,
    isVoided,
    voidedReasonId,
    prepStationIds,
    printJobIdsPerPrepStation
  }
});
var updateComboElementVoided = (payload) => ({
  type: UPDATE_COMBO_ELEMENT_VOIDED,
  payload
});
var copySentTicketElementConfig = (orderId, ticketElementId) => ({
  type: COPY_SENT_TICKET_ELEMENT_CONFIG,
  payload: {
    orderId,
    ticketElementId
  }
});
var updateComboObjectPreview = (payload) => ({
  type: UPDATE_COMBO_OBJECT_PREVIEW,
  payload
});
var selectTicketCurrentSeat = (selectedSeat, seatingPromptMode, order) => ({
  type: SELECT_CURRENT_SEAT,
  payload: { selectedSeat, order, seatingPromptMode }
});
var selectTicketNextSeat = (seatsOccupied, seatingPromptMode, order) => ({
  type: SELECT_NEXT_SEAT,
  payload: { seatsOccupied, order, seatingPromptMode }
});
var selectTicketPreviousSeat = (seatsOccupied, seatingPromptMode, order) => ({
  type: SELECT_PREVIOUS_SEAT,
  payload: { seatsOccupied, order, seatingPromptMode }
});
var setTicketElementShared = (orderId, ticketElementId, isSeatingModeEnabled, isCombo, shareCase, splitType, globalQuantity) => ({
  type: isCombo ? SET_COMBO_ELEMENT_SHARE : SET_TICKET_ELEMENT_SHARE,
  payload: {
    orderId,
    ticketElementId,
    isSeatingModeEnabled,
    isCombo,
    shareCase,
    splitType,
    globalQuantity
  }
});
var setOrderSearchResult = (payload) => ({
  type: SET_ORDER_SEARCH_RESULTS,
  payload
});
var resetOrderSearchResultBarCodeOrder = () => ({
  type: RESET_ORDER_SEARCH_RESULTS_BAR_CODE_ORDER
});
var resetModifierGroupSelectedToConfigWhenSent = (orderId, ticketElementId, modifierGroupId, isSeatingModeEnabled, isIngredientsActive) => ({
  type: RESET_MODIFIER_GROUP_SELECTED_TO_CONFIG_WHEN_SENT,
  payload: {
    orderId,
    ticketElementId,
    modifierGroupId,
    isSeatingModeEnabled,
    isIngredientsActive
  }
});
var moveCheckElements = (orderId, checkElementIds, checkToId) => ({
  type: MOVE_CHECK_ELEMENTS,
  payload: { orderId, checkElementIds, checkToId }
});
var movePayments = (orderId, paymentsToCheckIdsMap, checkToId) => ({
  type: MOVE_PAYMENTS,
  payload: { orderId, paymentsToCheckIdsMap, checkToId }
});
var renameCheck = (orderId, checkId, newName) => ({
  type: RENAME_CHECK,
  payload: { orderId, checkId, newName }
});
var closeCheck = (orderId, checkId, globalState) => ({
  type: CLOSE_CHECK,
  payload: { orderId, checkId, globalState }
});
var mergeChecks = (orderId, checkIds) => ({
  type: MERGE_CHECKS,
  payload: { orderId, checkIds }
});
var deleteEditableCheck = (orderId, checkId) => ({
  type: DELETE_EDITABLE_CHECK,
  payload: { orderId, checkId }
});
var deleteAllEditableChecks = (orderId) => ({
  type: DELETE_ALL_EDITABLE_CHECKS,
  payload: { orderId }
});
var unSplitCheckElement = (orderId, checkId, checkElementId) => ({
  type: UN_SPLIT_CHECK_ELEMENT,
  payload: { orderId, checkId, checkElementId }
});
var carryOverModifiersSelected = (payload, seatingData) => ({
  type: CARRY_OVER_MODIFIERS_SELECTED,
  payload: __spreadValues(__spreadValues({}, payload), seatingData)
});
var applySpecialToTicket = (payload) => ({
  type: APPLY_SPECIAL_TO_TICKET,
  payload
});
var rollUpTicketElements = (orderId, ticketElementIds) => ({
  type: ROLL_UP_TICKET_ELEMENTS,
  payload: {
    orderId,
    ticketElementIds
  }
});
var rollUpTicketCombos = (orderId, comboElementIds) => ({
  type: ROLL_UP_COMBO_ELEMENTS,
  payload: {
    orderId,
    comboElementIds
  }
});
var clearAllSeatTags = (payload) => ({
  type: CLEAR_ALL_SEAT_TAGS,
  payload
});
var finishItemModifyingAction = () => ({
  type: MODIFY_ITEM_END
});
var deleteEmptyChecks = (orderId) => ({
  type: DELETE_EMPTY_CHECKS,
  payload: { orderId }
});
var makeComboFromTicketElement = (payload) => ({
  type: MAKE_COMBO_FROM_TICKET_ITEM,
  payload
});
var removeComboElement = (orderId, comboElementId) => ({
  type: REMOVE_COMBO_ELEMENT,
  payload: {
    comboElementId,
    orderId,
    isCombo: true
  }
});
var cancelComboElement = (orderId, comboElementId) => ({
  type: CANCEL_COMBO_ELEMENT,
  payload: {
    comboElementId,
    orderId
  }
});
var setTicketElementQuantity = (quantity, orderId, ticketElementId, isSeatingModeEnabled, isCombo) => ({
  type: isCombo ? SET_COMBO_ELEMENT_QUANTITY : SET_TICKET_ELEMENT_QUANTITY,
  payload: {
    ticketElementId,
    orderId,
    quantity,
    isSeatingModeEnabled,
    isCombo
  }
});
var incrementNumberOfSeatsOccupied = (orderId) => ({
  type: INCREMENT_NUMBER_OF_SEATS,
  payload: {
    orderId
  }
});
var setModifierGroupSelected = (payload, orderId, ticketElementId, seatingData) => ({
  type: SET_TICKET_MODIFIER_GROUPS_SELECTED,
  payload: __spreadProps(__spreadValues(__spreadValues({}, payload), seatingData), { orderId, ticketElementId })
});
var selectNoneModifierItems = (orderId, ticketElementId, seatingData, modifierGroupId, globalState) => ({
  type: SELECT_NONE_MODIFIER_ITEMS,
  payload: __spreadProps(__spreadValues({
    orderId,
    ticketElementId,
    modifierGroupId
  }, seatingData), {
    globalState
  })
});
var toggleModifierItemSelected = (orderId, ticketElementId, modifierGroupId, modifierItemId, customizer, modifierTag, seatingData, globalQuantity, globalState, operation, sortPriority) => ({
  type: TOGGLE_MODIFIER_ITEM_SELECTED,
  payload: __spreadProps(__spreadValues({
    orderId,
    ticketElementId,
    modifierGroupId,
    modifierItemId,
    customizer,
    modifierTag,
    globalQuantity
  }, seatingData), {
    globalState,
    operation,
    sortPriority
  })
});
var applyDiscountToOrder = (discount, orderId, removeExclusive) => ({
  type: APPLY_DISCOUNT_TO_ORDER,
  payload: {
    orderId,
    discount,
    removeExclusive
  }
});
var updateOrderDiscount = (orderId, discount, discountId, tabletGeneratedId, isCustom) => ({
  type: UPDATE_ORDER_DISCOUNT,
  payload: {
    orderId,
    discount,
    discountId,
    tabletGeneratedId,
    isCustom
  }
});
var updateTicketItemDiscount = (orderId, ticketElementId, discount, discountId, tabletGeneratedId, isCustom, seatingData, isCombo) => ({
  type: isCombo ? UPDATE_TICKET_COMBO_DISCOUNT : UPDATE_TICKET_ELEMENT_DISCOUNT,
  payload: __spreadValues({
    orderId,
    ticketElementId,
    discount,
    discountId,
    tabletGeneratedId,
    isCustom
  }, seatingData)
});
var clearUnsentItems = (orderId, currentSeat, checkForSplit, ticketElementIds, clearableCombos, ignoredTicketElementIds) => ({
  type: CLEAR_UNSENT_ITEMS,
  payload: {
    currentSeat,
    ticketElementIds,
    clearableCombos,
    orderId,
    checkForSplit,
    ignoredTicketElementIds
  }
});
var applyDiscountToItem = (discount, itemIds, comboIds, orderId, removeExclusive, currentSeat, checkForSplit) => ({
  type: APPLY_DISCOUNT_TO_ITEMS,
  payload: {
    orderId,
    discount,
    itemIds,
    comboIds,
    removeExclusive,
    currentSeat,
    checkForSplit
  }
});
var removeDiscountFromElement = (orderId, ticketElementId, id, tabletGeneratedId, seatingData, isCombo) => ({
  type: isCombo ? REMOVE_DISCOUNT_FROM_COMBO : REMOVE_DISCOUNT_FROM_ITEM,
  payload: __spreadValues({
    orderId,
    ticketElementId,
    id,
    tabletGeneratedId,
    isCombo
  }, seatingData)
});
var removeDiscountFromOrder = (orderId, id, tabletGeneratedId) => ({
  type: REMOVE_DISCOUNT_FROM_ORDER,
  payload: {
    orderId,
    id,
    tabletGeneratedId
  }
});
var toggleOnHoldByTicketElementIdAndOrderId = (orderId, ticketElementId, currentSeat, seatSplitRequired) => ({
  type: TOGGLE_TICKET_ELEMENT_ON_HOLD,
  payload: {
    orderId,
    ticketElementId,
    currentSeat,
    seatSplitRequired
  }
});
var updateTicketElementBasePriceByTicketElementId = (orderId, ticketElementId, overridePrice, currentSeat, seatSplitRequired, isCombo) => ({
  type: isCombo ? UPDATE_COMBO_ELEMENT_BASE_PRICE : UPDATE_TICKET_ELEMENT_BASE_PRICE,
  payload: {
    orderId,
    ticketElementId,
    overridePrice,
    currentSeat,
    seatSplitRequired,
    isCombo
  }
});
var revertTicketElementPriceByTicketElementId = (orderId, ticketElementId, currentSeat, seatSplitRequired, isCombo) => ({
  type: REVERT_TICKET_ELEMENT_BASE_PRICE,
  payload: {
    orderId,
    ticketElementId,
    currentSeat,
    seatSplitRequired,
    isCombo
  }
});
var createCheck = (orderId, checkId, checkDefaults) => ({
  type: CREATE_CHECK,
  payload: {
    orderId,
    checkId,
    checkDefaults
  }
});
var rollUpOrderCheckElements = (orderId) => ({
  type: ROLL_UP_CHECK_ELEMENTS,
  payload: {
    orderId
  }
});
var updateCheckOrderDiscounts = (orderId) => ({
  type: UPDATE_CHECK_ORDER_DISCOUNTS,
  payload: {
    orderId
  }
});
var voidAllChecks = (orderId) => ({
  type: VOID_ALL_CHECKS,
  payload: {
    orderId
  }
});
var dumpDefaultCheck = (orderId) => ({
  type: DUMP_DEFAULT_CHECK,
  payload: {
    orderId
  }
});
var cleanDisplayCheckElements = (orderId, checkId) => ({
  type: CLEAN_DISPLAY_CHECK_ELEMENTS,
  payload: {
    orderId,
    checkId
  }
});
var createDisplayCheckElements = (orderId, checkId) => ({
  type: CREATE_DISPLAY_CHECK_ELEMENTS,
  payload: {
    orderId,
    checkId
  }
});
var splitCheckElementsWays = (payload) => ({
  type: SPLIT_CHECK_ELEMENTS_WAYS,
  payload
});
var splitCheckElementEvenly = (payload) => ({
  type: SPLIT_CHECK_ELEMENT_EVENLY,
  payload
});
var ungroupCheckElements = (payload) => ({
  type: UNGROUP_CHECK_ELEMENTS,
  payload
});
var splitCheckBySeats = (payload) => ({
  type: SPLIT_CHECK_BY_SEATS,
  payload
});
var splitCheckElementBySeats = (payload) => ({
  type: SPLIT_CHECK_ELEMENT_BY_SEATS,
  payload
});
var splitCheckIntoNNewChecks = (payload) => ({
  type: SPLIT_CHECK_INTO_N_NEW_CHECKS,
  payload
});
var openCheck = (orderId, checkId) => ({
  type: OPEN_CHECK,
  payload: {
    orderId,
    checkId
  }
});
var voidCheck = (orderId, checkId) => ({
  type: VOID_CHECK,
  payload: {
    orderId,
    checkId
  }
});
var addCheckPayment = (orderId, checkId, payment, globalState) => ({
  type: ADD_CHECK_PAYMENT,
  payload: {
    orderId,
    checkId,
    payment,
    globalState
  }
});
var voidPayment = (orderId, payment) => ({
  type: VOID_PAYMENT,
  payload: {
    orderId,
    payment
  }
});
var transferPayment = (orderId, transferredOrderId, transferredCheckId, payment) => ({
  type: TRANSFER_PAYMENT,
  payload: {
    orderId,
    transferredOrderId,
    transferredCheckId,
    payment
  }
});
var updatePayment = (orderId, payment) => ({
  type: UPDATE_PAYMENT,
  payload: {
    orderId,
    payment
  }
});
var toggleItemIngredient = (payload) => ({
  type: TOGGLE_ITEM_INGREDIENT,
  payload
});
var incrementItemIngredient = (payload) => ({
  type: INCREMENT_ITEM_INGREDIENT,
  payload
});
var decrementItemIngredient = (payload) => ({
  type: DECREMENT_ITEM_INGREDIENT,
  payload
});
var applyTipToOrder = (tipList, rootState) => ({
  type: APPLY_PAYMENT_TIP_ADJUSTMENT,
  payload: { tipList, rootState }
});
var addRegisterOpenItem = (payload) => ({
  type: ADD_REGISTER_OPEN_ITEM,
  payload
});
var startItemModifying = (payload) => ({
  type: MODIFY_ITEM_START,
  payload
});
var updateFireTimesField = (payload) => {
  return {
    type: UPDATE_FIRE_TIMES_FIELD,
    payload
  };
};
var voidOrderAction = (orderId) => ({
  type: VOID_ORDER,
  payload: orderId
});
var flushDebounceUpdate = (orderId, actionType) => ({
  type: FLUSH_DEBOUNCE_UPDATE_ORDER,
  payload: { orderId, actionType }
});
var switchOrderListPrice = (orderId, priceList, isSeatingEnabled, lockPrice) => ({
  type: SWITCH_PRICE_LIST,
  payload: { orderId, priceList, isSeatingEnabled, lockPrice }
});

export { actionCreators_exports, addCheckPayment, addModifierItemToModifierGroupItemObj, addRegisterOpenItem, addSessionOrder, addSpecialObjectsToOrder, applyDiscountToItem, applyDiscountToOrder, applySpecialToTicket, applyTipToOrder, cancelComboElement, carryOverModifiersSelected, cleanDisplayCheckElements, clearAllSeatTags, clearUnsentItems, closeCheck, copySentTicketElementConfig, createCheck, createDisplayCheckElements, decrementItemIngredient, decrementModifierItemSelected, decrementNestedModifierItemSelected, decrementSeatQuantity, deleteAllEditableChecks, deleteEditableCheck, deleteEmptyChecks, deleteNestedModifierItemSelected, deleteTicketModifierItemSelected, dumpDefaultCheck, duplicateTicketElement, enterToOrderAction, exitFromOrderAction, finishItemModifyingAction, flushDebounceUpdate, incrementItemIngredient, incrementModifierItemSelected, incrementNestedModifierItemSelected, incrementNumberOfSeatsOccupied, incrementSeatQuantity, kitchenItemClearPrintingError, leavingOrderActionWS, makeComboFromTicketElement, mergeChecks, moveCheckElements, movePayments, openCheck, removeComboElement, removeDiscountFromElement, removeDiscountFromOrder, removeOrder, removeRegisterComboItem, removeTicketElement, renameCheck, replaceOrderTabletGeneratedId, replaceSessionOrder, resetModifierGroupSelected, resetModifierGroupSelectedToConfigWhenSent, resetOrderSearchResultBarCodeOrder, resetTicketSpecials, revertTicketElementPriceByTicketElementId, rollUpOrderCheckElements, rollUpOrderSearchCheckElements, rollUpTicketCombos, rollUpTicketElements, selectCustomizerSubcategory, selectNoneModifierItems, selectNoneNestedModifierItemSelected, selectRegisterCombo, selectRegisterComboItem, selectRegisterItem, selectTicketCurrentSeat, selectTicketNextSeat, selectTicketPreviousSeat, setCurrentTicketElementItemObj, setModifierGroupSelected, setOrderLocallyForPayment, setOrderSearchResult, setOrders, setSeatQuantity, setSeatTags, setTicketElementQuantity, setTicketElementShared, splitCheckBySeats, splitCheckElementBySeats, splitCheckElementEvenly, splitCheckElementsWays, splitCheckIntoNNewChecks, startItemModifying, switchOrderListPrice, toggleItemIngredient, toggleModifierItemSelected, toggleNestedModifierItemSelected, toggleNoneNestedModifierItemSelected, toggleOnHoldByTicketElementIdAndOrderId, toggleSeatQuantity, toggleTicketElementSeatShared, transferPayment, unShareTicketElement, unSplitCheckElement, ungroupCheckElements, ungroupTicketElementByQty, ungroupTicketElementBySeats, ungroupTicketElementBySingleSeat, updateCheckOrderDiscounts, updateComboElementVoided, updateComboObjectPreview, updateCompletedSections, updateFireTimesField, updateModifierPrices, updateOrderData, updateOrderDiscount, updateOrderSearchResultData, updatePayment, updateSessionOrder, updateTicketElementBasePriceByTicketElementId, updateTicketElementCourse, updateTicketElementField, updateTicketElementInstructions, updateTicketElementVoided, updateTicketItemDiscount, updateTicketModifierGroupItem, voidAllChecks, voidCheck, voidOrderAction, voidPayment };
